<div class="flex justify-center my-4">
  <lib-adresse
    [labels]="'lib.adresse' | translate"
    [language]="language$ | async"
    class="w-full"
    [addresses]="addressList"
    [adresseSelected]="selectedAddress"
    [defaultAddressId]="defaultAddressId"
    (getAdresseById)="getAdressToUpdate($event)"
    [bank]="theme"
    (addAdresse)="onCreateAddress($event)"
    (updateAdresse)="onUpdateAddress($event)"
    (delete)="onDeleteAddress($event)"
    (wilayaSelected)="onSelectWilaya($event)"
    [towns]="townsList"
  ></lib-adresse>
</div>

<!--Snackbar to display after a success or failed operation on an address-->
@if (showSnackbar) {
  <lib-snackbar
    [labels]="'lib.snackbar' | translate"
    [bank]="theme"
    [theme]="snackbarParams.theme"
    [title]="snackbarParams.message"
    [showIconLeft]="true"
    [showIconRight]="false"
    [position]="'bottom'"
    >
  </lib-snackbar>
}
